module.exports = __webpack_public_path__ + "img/logoWZain.0d663445.svg";